import 'angular:locale/data:es';
import 'angular:locale/data:en';
import 'angular:locale/data:pt';
import 'angular:locale/data:en-US';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
